<template>
  <img :src="logo" loading="lazy" width="190" height="53" alt="Canyon logo" />
</template>

<script setup lang="ts">
const { logo } = useRuntimeConfig().public.frontkit;
</script>
